var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticStyle:{"line-height":"1.2em"},style:({ fontSize: _vm.fontSize, color: _vm.color, fontWeight: _vm.weight, fontStyle: _vm.fontStyle}),domProps:{"innerHTML":_vm._s(_vm.hyperText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }